import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

type SkeletonType = 'text' | 'circular' | 'rectangular' | 'rounded';

interface ShimmerProps {
  variant?: SkeletonType;
  count?: number;
  width?: number | string;
  height?: number | string;
  spacing?: number;
  fontSize?: string;
}

const Shimmer: React.FC<ShimmerProps> = ({ variant = 'text', count = 1, width = '100%', height = 20, spacing = 1, fontSize = '1rem' }) => {
  return (
    <Stack spacing={spacing}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant={variant}
          width={width}
          height={variant === 'text' ? undefined : height}
          sx={variant === 'text' ? { fontSize } : {}}
        />
      ))}
    </Stack>
  );
};

export default Shimmer;
